export default "__VITE_ASSET__89e1b01d__"